import Link from "next/link";
import { Article } from "../types";

export const ArticleTags = ({ article }: { article: Article }) => {
  return article.categories.slice(0, 3).map((category) => (
    <Link
      href={`/categories/${category.slug}`}
      key={`category-${category.id}`}
      className="inline-block
      px-4 py-1 mr-2 mb-2 text-gray-700 font-body
      uppercase border border-gray-400 rounded-full text-nowrap transition-colors duration-300 hover:border-black hover:black
      text-[10px] md:text-xs xl:text-sm"
    >
      {String(category.name) || ""}
    </Link>
  ));
};
